/* components/LookbookSlider.ts

*/

import { Component, Ref, Prop, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { EastSlider } from '../EastSlider/EastSlider';

@Component
export class LookbookSlider extends ThemeComponent {

    @Ref() collection!: HTMLDivElement;

    private slider = this.querySelector('east-slider') as EastSlider;

    async init() {
        if (this.slider) {

            this.slider.swiper?.on('slideChange', (event) => {
                // Get the collection handle from a data attr on the slide element
                const activeSlide = event.slides[event.activeIndex];
                const collectionHandle = activeSlide?.getAttribute('data-collection-handle');
                if (activeSlide && collectionHandle) {

                    this.renderProductCards(collectionHandle).catch((error) => {
                        throw Error(error.message);
                    });
                }
            });

            if (this.slider.classList.contains('swiper-initialized')) {
                const activeSlide = this.slider?.querySelector('.swiper-slide-active');
                const collectionHandle = activeSlide?.getAttribute('data-collection-handle');
                if (collectionHandle) {
                    this.renderProductCards(collectionHandle).catch((error) => {
                        throw Error(error);
                    });
                }
            } else {
                this.slider.swiper?.on('init', (event) => {
                    // Get the collection handle from a data attr on the slide element
                    const activeSlide = event.slides[event.activeIndex];
                    const collectionHandle = activeSlide?.getAttribute('data-collection-handle');
                    if (activeSlide && collectionHandle) {
                        this.renderProductCards(collectionHandle).catch((error) => {
                            throw Error(error.message);
                        });
                    }
                });
            }

        }
    }

    async renderProductCards(collectionHandle: string) {
        await fetch(`/collections/${collectionHandle}?section_id=dynamic-collection`)
            .then((response) => response.text())
            .then((text) => {
                this.collection.innerHTML = text;
            }).catch((error) => {
                if (typeof error === "string") {
                    throw Error(error);
                } else if (error instanceof Error) {
                    throw Error(error.message);
                }
            });
    }
}
